import "./_icon-button.scss";

import classNames from "classnames";

import Button from "../Button";
import {ButtonProps} from "../Button.types";

function IconButton({children, customClassName, ...otherProps}: ButtonProps) {
  return (
    <Button customClassName={classNames("icon-button", customClassName)} {...otherProps}>
      {children}
    </Button>
  );
}

export default IconButton;
